import React from 'react';

import * as analytics from 'analytics/Analytics';
import {REQUESTS_V2_ANALYTICS_ACTIONS} from 'constants/analytics-products/RequestsV2AnalyticsConstants';
import {StringIDFolder} from 'constants/FolderConstants';
import {ActionMethod, ActionOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import RequestV2SubmissionProgressAndOutputs from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionProgressAndOutputs';
import useOnMount from 'ui-library/hooks/useOnMount';

interface RequestV2SubmissionProgressAndOutputsTabViewProps {
  requestV2SubmissionId: string;
  folder: StringIDFolder;
}

export default function RequestV2SubmissionProgressAndOutputsTabView(
  props: RequestV2SubmissionProgressAndOutputsTabViewProps
): JSX.Element {
  useOnMount(() => {
    analytics.trackEvent(REQUESTS_V2_ANALYTICS_ACTIONS.CLICKED_REQUEST_V2_PROGRESS_AND_OUTPUTS_TAB, {
      request_v2_submission_id: props.requestV2SubmissionId,
      action_origin: ActionOrigin.REQUEST_V2_SUBMISSION,
      action_method: ActionMethod.BUTTON_CLICK,
    });
  });

  return (
    <div className="react-tab-container" style={{padding: 0}}>
      <RequestV2SubmissionProgressAndOutputs {...props} />
    </div>
  );
}
